module.exports = __webpack_public_path__ + "assets/img/gfpd3.30c3ee46.png";